import { TextField } from "@mui/material";
import '../pages/Gachapon.scss';
import { useLottie } from "lottie-react";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { Rabbit } from "../api/types";

import gachaponButton from "./gachapon_button.json";
import gachaponBouncing from "./gachapon_bouncing.json";
import gachaponMachine from "./gachapon_paymachine.json";
import useSound from 'use-sound';


const GachaponBouncing = () => {
  const options = {
    animationData: gachaponBouncing,
    loop: true,
    autoplay: true,
    onComplete: () => {
      
    }
  };

  const { View, play } = useLottie(options);

  return <div className="gachaponBalls">
      {View}
  </div>;
};

const GachaponKnob = (props:any) => {
  const { isClicked, onSpin, setKnob, isAuthorized } = props
  
  const options = {
    animationData: gachaponButton,
    loop: false,
    autoplay: false,
    onComplete: () => {
      setTimeout(() => { setKnob(false) } ,4000);
      onSpin()
      setTimeout(() => {
        stop()
      }, 1000)
    }
  };
  const { View, play, stop, setSpeed } = useLottie(options);
 

  useEffect(() => {
      if(isClicked === true && isAuthorized){
          setSpeed(1)
          play()
      }      
  }, [isClicked, isAuthorized])

  return <>
    
    {View}
  </>;
};


const GachaponPayMachine = (props:any) => {

  const options = {
    animationData: gachaponMachine,
    loop: true,
    autoplay: true,
    onComplete: () => {
      play()
    }
  };
  const { View, play } = useLottie(options);
  
  return <>{View}</>;
};


  const GachaponMachine = forwardRef(({onSpin, isAuthorized, currentRabbit, showError, nextSpin, pay2SpinEnabled, onPayment, txId, price, onTxChange, claimFragments, mint_name} : {onSpin: () => Promise<void>, isAuthorized: string, currentRabbit:Rabbit | undefined, showError:(message:string) => void, nextSpin: any, pay2SpinEnabled: boolean, onPayment: () => Promise<string>, txId: string, price:any, onTxChange: (sig: string) => void, claimFragments: () => void, mint_name: string}, ref: React.Ref<any>) => {
    let [knob, setKnob] = useState<Boolean>(false);
    let [transactionID, setTransactionID] = useState("");
    let [transactionField, setTransactionField] = useState<Boolean>(false);

    const [spinSound, spinSoundData] = useSound('/audio/spin.mp3', { volume: 0.06 });
    const [revealSound, revealSoundData] = useSound('/audio/prize_reveal.mp3', { volume: 0.06 });
    const spins_remaining = (currentRabbit && currentRabbit.spins_remaining) ? currentRabbit.spins_remaining : 0
    const availableSpins = (spins_remaining > 1) ? `${spins_remaining} Spins` : `${spins_remaining} Spin`;

    useImperativeHandle(ref, () => ({
      clickKnob() {
        setKnob(true);
        spinSound();
      }
    }));

    let spinScreen = (currentRabbit && currentRabbit.available) ? `${availableSpins}<br/><span>Available</span>` : `Next spin at<br><span>${nextSpin.short}</span>`
    spinScreen = (pay2SpinEnabled) ? `<span class="p2s-price">${price} ${mint_name || 'SOL'}</span>` : spinScreen
      return (
        <div className="Gachapon">
            {pay2SpinEnabled ? <GachaponPayMachine/> : <img className="gachaponMachine" src={process.env.PUBLIC_URL + '/images/gachapon.png'} alt="" />}
            <GachaponBouncing />
            {nextSpin ? <div className="Gachapon--Container--Machine--Counter" dangerouslySetInnerHTML={{ __html: spinScreen}}></div> : null }
            <div  className="Gachapon--Container--Machine--Knob">
                <button className="Knob--Button" onClick={async() => {
                    // pay 2 spin flow
                    if (pay2SpinEnabled) {
                      if (!isAuthorized) {
                        showError("Please authorize.");
                        return;
                      }

                      if (txId) {
                        setTransactionID(txId);
                      } else if (!transactionID) {
                        const tx = await onPayment();
                        if (!tx) {
                          showError("Transaction failed.");
                          return;
                        }
                      }
                      
                      setKnob(true); 
                      spinSound();
                      return; 
                    }
                    
                    // regular gacha flow
                    if(!currentRabbit) {
                      showError("You haven't selected any Rabbit.")
                    } else if(currentRabbit.available === false) {
                      showError("Next spin available at "+nextSpin.long)
                    } else if(isAuthorized && knob === false) { 
                      setKnob(true); 
                      spinSound();
                    } 
                  }}></button>
                <GachaponKnob 
                  onSpin={() => { 
                    setTimeout(() => { revealSound(); setTransactionID(''); }, 500);  
                    setTimeout(() => { setKnob(false) } ,4000);
                    onSpin(); 
                  }} 
                  setKnob={(value:boolean) => { setKnob(false)}} 
                  isAuthorized={isAuthorized} 
                  isClicked={knob} />
                  
            </div>
            
            {<div className='Gachapon-Machine-tx'>
              <span className="button" onClick={() => { setTransactionField(!transactionField) }}>{pay2SpinEnabled ? "Didn't get your prize?" : "Didn't get your extra spin?"}</span>
              <div className={`Gachapon-Machine-field ${transactionField ? "show" : ""}`}>
                <span>{pay2SpinEnabled ? "Enter TX ID and spin the Gacha again" : "Enter TX ID and claim your extra spin again"}</span>
                <input 
                    type="text" 
                    value={transactionID}
                    onChange={(v) => {
                      setTransactionID(v.target.value);
                      onTxChange(v.target.value);
                    }}
                    onKeyPress={event => {
                      if (event.key !== 'Enter') return;
                      if(pay2SpinEnabled){
                        setKnob(true); 
                        spinSound();
                      } else {
                        claimFragments();
                      }
                    }}
                    style={{marginBottom: '0px'}}
                  />
                  <span className="close-field"  onClick={() => { setTransactionField(!transactionField) }} style={{margin: 0, cursor: "pointer", padding: "10px 0 0"}}>Close</span>
                </div>
              </div>}
        </div>
      )

  });

  export default GachaponMachine;